import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { convertDataDictionaryToMarkdown, convertDeltaTableDictToMarkdown } from '@app/utils';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { IDocument } from '@common/models/Document/IDocument';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-table-summary-sidebar',
  templateUrl: './table-summary-sidebar.component.html',
  styleUrls: ['./table-summary-sidebar.component.scss'],
  providers: [DialogService]
})
export class TableSummarySidebarComponent implements OnChanges {
  @Input() sidebarVisible: boolean;
  @Input() header:string;
  @Input() summaryData: string;
  @Input() documentName:string;

  @Input() documentModel: IDocument;
  @Input() deltaTable: IDeltaTable;
  
  @Output() emitSidebarUpdate = new EventEmitter<boolean>();
  parsedSummaryData = "";

  constructor(
    public dialogService: DialogService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['summaryData']) {
      if(this.header==='Summary'){
        this.documentModel=null
        this.deltaTable=null
      }
    }
    if (changes['documentModel'] || changes['sidebarVisible']?.currentValue === true) {
      if(this.documentModel?.dataDictionary){
        this.parsedSummaryData = convertDataDictionaryToMarkdown(this.documentModel)
      }
    }
    if ((changes['deltaTable'] || changes['sidebarVisible']?.currentValue === true)  && this.header!=='Summary') {
      if(this.deltaTable?.dataDictionary){
        this.parsedSummaryData = convertDeltaTableDictToMarkdown(this.deltaTable?.dataDictionary,this.deltaTable?.tableName)
      }
    }
    
  }

  onCloseSidebar(){
    this.emitSidebarUpdate.emit(false)
  }

}
